import ExportIcon from './component'

export default ExportIcon
